import React, { FunctionComponent, memo } from 'react';
import className from '@wavevision/class-name';
import { mergeAll } from 'ramda';

import { CLASSNAME_MODIFIERS } from '@flowgate/core/assets/app/constants';

import Svg from '../../../Svg/assets/scripts';

import { ButtonProps } from './types';

const buttonClassName = className<ButtonProps>('button', () => {
  const baseModifiers = mergeAll(CLASSNAME_MODIFIERS.map(m => ({ [m]: true })));
  return {
    ...baseModifiers,
    block: true,
    icon: true,
    label: true,
    large: true,
  };
});

const Button: FunctionComponent<ButtonProps> = props => {
  const className = buttonClassName({ props });
  return (
    <button
      className={className.block()}
      disabled={props.disabled}
      onClick={props.onClick}
      type="button"
    >
      <span className="button__inner">
        {props.icon && <Svg symbol={props.icon} />}
        {props.label && <span className="button__label">{props.label}</span>}
      </span>
    </button>
  );
};

export default memo<ButtonProps>(Button);
